import Vue from 'vue'
import Router from 'vue-router'

const studentBasepage = () => import('@/views/student');
const homepage = () => import('@/views/homepage');
const login = () => import('@/views/login');
const changePassword = () => import('@/views/changePassword');
const classcircleIndex = () => import('@/views/classcircle/classcircleIndex');
const classcircleDetail = () => import('@/views/classcircle/classcircleDetail');
const newsDetail = () => import('@/views/news/newsDetail');
const medalList = () => import('@/views/medal/medalList');
const homeworkList = () => import('@/views/homework/homeworkList');
const homeworkDetail = () => import('@/views/homework/homeworkDetail');
const scoreAnalysisList = () => import('@/views/scoreAnalysis/scoreAnalysisList');
const evTeaList = () => import('@/views/evTea/evTeaList');
/*学生基本信息*/
const studentInfo = () => import('@/views/studentInfo/studentInfoIndex');
const studentInfoProfile = () => import('@/views/studentInfo/profile');
const examResultSummary = () => import('@/views/studentInfo/examResult/examResultSummary');
const examResultDetail = () => import('@/views/studentInfo/examResult/examResultDetail');
const classEvaluationSummary = () => import('@/views/studentInfo/classEvaluation/classEvaluationSummary');
const classEvaluationDetail = () => import('@/views/studentInfo/classEvaluation/classEvaluationDetail');
const educateEvaluationSummary = () => import('@/views/studentInfo/educateEvaluation/educateEvaluationSummary');
const educateEvaluationDetail = () => import('@/views/studentInfo/educateEvaluation/educateEvaluationDetail');
const physicalHealthSummary = () => import('@/views/studentInfo/physicalHealth/physicalHealthSummary');
const winMedalIndex = () => import('@/views/studentInfo/winMedalIndex');

import questionnaireRoutes from './questionnaire';

const ErrorPage = () => import('@/views/ErrorPage/');
const redirect = () => import('@/views/redirect');

Vue.use(Router);

export default new Router({
    routes: [{
        path: '/',
        redirect: '/login'
    }, {
        path: '*',
        redirect: '/error/404'
    }, {
        path: '/error/:errorCode',
        component: ErrorPage,
        props: true
    }, {
        path: '/redirect',
        component: redirect
    }, {
        path: '/student',
        name: 'student',
        component: studentBasepage,
        children: [
            ...questionnaireRoutes,
            {
            path: '',
            redirect: 'homepage'
        }, {
            path: 'homepage',
            name: 'homepage',
            component: homepage
        }, {
            path: 'classcircle',
            redirect: 'classcircle/classcircleIndex'
        }, {
            path: 'classcircle/classcircleIndex',
            name: 'classcircleIndex',
            component: classcircleIndex,
            meta: {
                permissionPath: '/classCircle/stuPc'
            }
        }, {
            path: 'classcircle/classcircleDetail',
            name: 'classcircleDetail',
            component: classcircleDetail,
            meta: {
                permissionPath: '/classCircle/stuPc'
            }
        }, {
            path: 'newsDetail',
            name: 'newsDetail',
            component: newsDetail,
            meta: {
                permissionPath: '/journalism/stuPc'
            }
        }, {
            path: 'medal',
            redirect: 'medal/medalList'
        }, {
            path: 'medal/medalList',
            name: 'medalList',
            component: medalList,
            meta: {
                permissionPath: '/schoolHonor/stuPc'
            }
        }, {
            path: 'evTea/evTeaList',
                name: 'evTeaList',
                component: evTeaList,
            }, {
            path: 'homework',
            redirect: 'homework/homeworkList'
        }, {
            path: 'homework/homeworkList',
            name: 'homeworkList',
            component: homeworkList,
            meta: {
                permissionPath: '/homework/stuPc'
            }
        }, {
            path: 'homework/homeworkDetail',
            name: 'homeworkDetail',
            component: homeworkDetail,
            meta: {
                permissionPath: '/homework/stuPc'
            }
        }, {
            path: 'scoreAnalysis',
            redirect: 'scoreAnalysis/scoreAnalysisList'
        }, {
            path: 'scoreAnalysis/scoreAnalysisList',
            name: 'scoreAnalysisList',
            component: scoreAnalysisList
        }, {
            path: 'studentInfo', // 学生个人档案
            component: studentInfo,
            children: [{
                path: '',
                redirect: 'profile'
            }, {
                path: 'profile', // 学生个人档案首页
                name: 'studentInforofile',
                component: studentInfoProfile,
                meta: {
                    isCached: true
                }
            }, {
                path: 'examResultSummary', // 成绩汇总
                name: 'examResultSummary',
                component: examResultSummary
            }, {
                path: 'examResultDetail', // 成绩详情
                name: 'examResultDetail',
                component: examResultDetail
            },{
                path: 'classEvaluationSummary', // 课堂评价汇总
                name: 'classEvaluationSummary',
                component: classEvaluationSummary,
                meta: {
                    permissionPath: '/schoolBehavior/stuPc'
                }
            },{
                path: 'classEvaluationDetail', // 课堂评价详情
                name: 'classEvaluationDetail',
                component: classEvaluationDetail,
                meta: {
                    permissionPath: '/schoolBehavior/stuPc'
                }
            }, {
                path: 'educateEvaluationSummary', // 德育评价汇总
                name: 'educateEvaluationSummary',
                component: educateEvaluationSummary,
                meta: {
                    permissionPath: '/schoolConduct/stuPc'
                }
            }, {
                path: 'educateEvaluationDetail', //德育评价详情
                name: 'educateEvaluationDetail',
                component: educateEvaluationDetail,
                meta: {
                    permissionPath: '/schoolConduct/stuPc'
                }
            },{
                path: 'homeworkList', // 学生作业列表
                name: 'studentHomeworkList',
                component: homeworkList,
                meta: {
                    permissionPath: '/homework/stuPc'
                }
            }, {
                path: 'homeworkDetail', // 学生作业详情
                name: 'studentHomeworkDetail',
                component: homeworkDetail,
                meta: {
                    permissionPath: '/homework/stuPc'
                }
            },{
                path: 'medalList', // 学生荣誉列表
                name: 'studentMedalList',
                component: medalList,
                meta: {
                    permissionPath: '/schoolHonor/stuPc'
                }
            },
            {
                path: 'physicalHealthSummary', // 体质健康
                name: 'physicalHealthSummary',
                component: physicalHealthSummary,
                meta: {
                    permissionPath: '/schoolFitnessTest/stuPc'
                }
            },
            {
                path: 'winMedalIndex', // 体质健康
                name: 'winMedalIndex',
                component: winMedalIndex,
                meta: {
                    permissionPath: '/schoolMedal/stuMedalDetails'
                }
            }
            ]
        }]
    }, {
        path: '/login',
        name: 'login',
        component: login
    }, {
        path: '/changePassword',
        name: 'changePassword',
        component: changePassword
    }, {
        path: '/agent/agentIndex',
        component: () => import('@/views/agent/agentIndex')
    }, ]
});



// WEBPACK FOOTER //
// ./src/router/index.js